import * as React from 'react'
import { Link } from 'react-router-dom'
import { ROUTES } from 'app/constants/routes'
import { useQueryCompanyNipMismatches } from '@/modules/shared/query-client/useQueryCompanyNipMismatches'

export const CompanyNipMismatchBanner: React.FC = () => {
  const { data } = useQueryCompanyNipMismatches()

  if (!data?.length) return null

  return (
    <details className="tw-mx-3 tw-mt-3 tw-rounded tw-border tw-border-warning tw-bg-warning/10 tw-px-4 tw-py-2 tw-text-sm">
      <summary className="tw-cursor-pointer tw-font-medium">
        {data.length === 1
          ? '1 firma ma inny NIP w profilu niż w ustawieniach firmy'
          : `${data.length} firm ma inny NIP w profilu niż w ustawieniach firmy`}
      </summary>
      <table className="tw-mt-2 tw-w-full">
        <thead>
          <tr className="tw-text-left">
            <th className="tw-py-1">Firma</th>
            <th className="tw-py-1">NIP w profilu</th>
            <th className="tw-py-1">NIP w ustawieniach</th>
          </tr>
        </thead>
        <tbody>
          {data.map((company) => (
            <tr key={company.companyId}>
              <td className="tw-py-1">
                <Link
                  to={ROUTES.AdministrationPanel.EditCompany.replace(
                    ':companyId',
                    company.companyId,
                  )}
                >
                  {company.companyName}
                </Link>
              </td>
              <td className="tw-py-1">{company.profileNip}</td>
              <td className="tw-py-1">{company.settingsNip}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </details>
  )
}
